import type { ReactNode } from 'react';
import { Boxes } from 'lucide-react';

// WHERE THE MESH WOULD BE, for a part that has none yet.
//
// It replaces a sentence. A part with no model said "No 3D model for this part yet." in
// grey text where the viewer goes, which is true and is also a dead end: everything you
// can do to a mesh in this phase — its measurements, its colour, the crops it is compared
// against — lives in the modal that opens by clicking the mesh, and a part with no mesh had
// nothing to click. The one part that most needs making was the one part with no way in.
//
// So the empty state is shaped like what it is missing: same white, same rounded frame, the
// same click. Dashed, because an outline that is not there yet is how a drawing says "this
// is planned" and a solid border would read as a viewer that failed to load.
export function MeshPlaceholder({ label, hint, icon, onOpen, className = '' }: {
  label: string;
  // The second line, smaller: what to DO about it. Omitted where the placeholder is
  // already inside the thing that does it — the modal's own viewport, where the
  // measurement fields are directly underneath.
  hint?: string;
  // WHAT THE ABSENCE IS. The cube is a mesh that has not been made; a spinner is one being
  // made right now. The same frame either way, because it is the same box holding the same
  // nothing — a run in flight that left the last mesh on screen was the panel claiming to
  // show a model that did not exist yet.
  icon?: ReactNode;
  // Given, the whole box is the way in. Withheld, it is a picture of an absence.
  onOpen?: () => void;
  className?: string;
}) {
  const Tag = onOpen ? 'button' : 'div';
  return (
    <Tag
      {...(onOpen ? { type: 'button' as const, onClick: onOpen } : {})}
      className={`flex flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-slate-300 bg-white p-6 text-center transition-colors ${
        onOpen ? 'cursor-zoom-in hover:border-blue-500' : ''
      } ${className}`}
    >
      {icon ?? <Boxes className="h-8 w-8 text-slate-300" />}
      <span className="text-sm text-slate-400">{label}</span>
      {hint && <span className="text-xs text-slate-400">{hint}</span>}
    </Tag>
  );
}
